<template>
  <div class="payrollDetails">
    <van-form label-width="120px">
      <div class="title">{{ $t.payrollDetails.title1 }}</div>

      <van-field :label="$t.payrollDetails.companyLogo" disabled>
        <template #input>
          <van-image
            width="80"
            height="80"
            fit="contain"
            :src="imgUrlFilter(form.CompanyLogoPic)"
            @click="imagePreview(imgUrlFilter(form.CompanyLogoPic))"
          />
        </template>
      </van-field>

      <van-field
        v-model="form.CompanyName"
        :label="$t.payrollDetails.companyName"
        disabled
      />

      <van-field
        v-model="form.CreateTime"
        :label="$t.payrollDetails.applyDate"
        disabled
      />

      <div v-for="(currency, index) in form.PayrollRequestAmountList" :key="index">
        <van-field
          :value="currency.PaymentAmount.toFixed(2)"
          :label="currency.CurrencySn"
          disabled
        />
      </div>

      <van-field
        v-model="form.PaymentRecordNumber"
        :label="$t.payrollDetails.paymentRecordNumber"
        disabled
        v-if="form.PaymentRecordNumber"
      />

      <van-field
        v-model="form.SupplierVoucherNumber"
        :label="$t.payrollDetails.voucherNumber"
        :placeholder="!isEdit ? '' : $t.meta.input"
        required
        :disabled="!isEdit ? true : false"
      />

      <div :class="!isEdit ? 'custom-date-disabled' : 'custom-date'">
        <div class="date-btn1">
          <div class="date-require">*</div>
          {{ $t.payrollDetails.lastDate }}
        </div>
        <div class="date-btn2" @click="showTimeDate">
          <span v-if="form.LatestPaymentDate" class="value">{{
            form.LatestPaymentDate
          }}</span>
          <span v-else class="placeholder"
            ><span v-if="isEdit">{{ $t.meta.select }}</span></span
          >
        </div>
      </div>

      <van-field
        v-model="form.Remark"
        :label="$t.payrollDetails.remark"
        :placeholder="!isEdit ? '' : $t.meta.input"
        type="textarea"
        rows="3"
        :disabled="!isEdit ? true : false"
      />

      <div class="title">{{ $t.payrollDetails.title2 }}</div>

      <van-field
        v-model="form.CustomerNumber"
        :label="$t.payrollDetails.supplierCode"
        disabled
      />

      <van-field
        v-model="form.CustomerName"
        :label="$t.payrollDetails.supplierName"
        disabled
      />

      <div class="payrollDetails-radio" v-if="isEdit">
        <div class="radio-label">
          <div class="radio-require1">*</div>
          {{ $t.payrollDetails.addAccount }}
        </div>
        <van-radio-group v-model="form.Currency" direction="horizontal">
          <van-radio
            v-for="(item, index) in form.PayrollRequestAmountList"
            :name="item"
            :key="index"
            >{{ item.CurrencySn }}</van-radio
          >
        </van-radio-group>
        <div class="radio-button">
          <van-button size="small" type="info" @click="handleAdd">{{
            $t.meta.confirm
          }}</van-button>
        </div>
      </div>

      <div class="title" v-if="form.CollectionAccountList.length > 0">
        {{ $t.payrollDetails.accountNo }}
      </div>
      <div class="multi-table" v-if="form.CollectionAccountList.length > 0">
        <div v-for="(item, index) in form.CollectionAccountList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">
              {{ item.CurrencySn }} {{ $t.payrollDetails.title3 }}
            </div>
            <div class="multi-table-btn" @click="handleDelByIndex(index)" v-if="isEdit">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.AccountName"
            :label="$t.payrollDetails.bankAccount"
            @click="pickerShow(index, 'showAccountPicker')"
            :placeholder="!isEdit ? '' : $t.meta.select"
            clickable
            readonly
            :disabled="!isEdit ? true : false"
          />
          <van-field
            v-model="item.BankName"
            :label="$t.payrollDetails.bankName"
            disabled
          />
          <van-field
            v-model="item.AccountNo"
            :label="$t.payrollDetails.accountNo"
            disabled
          />

          <van-collapse v-model="activeBankAccount">
            <van-collapse-item :name="index + 1">
              <template #title>
                <div class="collapse-title">
                  {{ $t.payrollDetails.accountDetail }}
                </div>
              </template>

              <van-field
                v-model="item.Currency"
                :label="$t.payrollDetails.accountCurrency"
                disabled
              />
              <van-field
                v-model="item.BankRegion"
                :label="$t.payrollDetails.bankRegion"
                disabled
              />
              <van-field v-model="item.SwiftCodeBankNo" label="Swift Code" disabled />
              <van-field
                v-model="item.BankAddress"
                :label="$t.payrollDetails.bankAddress"
                disabled
              />
              <van-field
                v-model="item.CompanyAddressEn"
                :label="$t.payrollDetails.addressEn"
                disabled
              />
              <van-field
                v-model="item.EnterpriseId"
                :label="$t.payrollDetails.enterpriseId"
                disabled
              />
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>

      <div class="title">{{ $t.payrollDetails.title4 }}</div>

      <div v-if="form.PaymentWorkOrderList">
        <div
          style="border-bottom: 1px solid #ebedf0"
          v-for="(item, index) in form.PaymentWorkOrderList"
          :key="index"
        >
          <van-collapse v-model="activeWorkOrder">
            <van-collapse-item :name="index + 1">
              <template #title>
                <div class="collapse-title">{{ item.FinancialAccountNo }}</div>
              </template>
              <van-field
                v-model="item.FinancialAccountNo"
                :label="$t.payrollDetails.financialAccountNo"
                disabled
              />
              <van-field
                v-model="item.WB_Number"
                :label="$t.payrollDetails.workNumber"
                disabled
              />
              <van-field v-model="item.CurrencySn" :label="$t.meta.currency" disabled />
              <van-field
                v-model="item.CostAmount"
                :label="$t.payrollDetails.payAmount"
                disabled
              />
              <van-field
                v-model="item.PaymentRequestsCount"
                :label="$t.payrollDetails.requestCount"
                disabled
              />

              <div
                class="subTotal"
                v-if="
                  item.CollectionSituationList && item.CollectionSituationList.length > 0
                "
              >
                <div class="subTotal-label">
                  {{ $t.payrollDetails.collection }}
                </div>
                <div
                  class="subTotal-item"
                  v-for="(collection, index) in item.CollectionSituationList"
                  :key="index"
                >
                  <div class="item1">{{ collection.CurrencySn }}</div>
                  <div class="item2">{{ collection.TotalAmount }}</div>
                </div>
              </div>

              <div v-if="item.TotalAmountReceivable[0]">
                <van-field
                  v-model="item.TotalAmountReceivable[0].value"
                  :label="
                    $t.payrollDetails.receivedTotal +
                    '(' +
                    item.TotalAmountReceivable[0].key +
                    ')'
                  "
                  disabled
                />
              </div>

              <div v-if="item.TotalAmountPayment[0]">
                <van-field
                  v-model="item.TotalAmountPayment[0].value"
                  :label="
                    $t.payrollDetails.paidTotal +
                    '(' +
                    item.TotalAmountPayment[0].key +
                    ')'
                  "
                  disabled
                />
              </div>

              <div v-if="item.TotalProfitAmount[0]">
                <van-field
                  v-model="item.TotalProfitAmount[0].value"
                  :label="
                    $t.payrollDetails.profitAmount +
                    '(' +
                    item.TotalProfitAmount[0].key +
                    ')'
                  "
                  disabled
                />
              </div>

              <div v-if="item.TotalCreditAmountPayment[0]">
                <van-field
                  v-model="item.TotalCreditAmountPayment[0].value"
                  :label="
                    $t.payrollDetails.totalcreditAmount +
                    '(' +
                    item.TotalCreditAmountPayment[0].key +
                    ')'
                  "
                  disabled
                />
              </div>

              <van-field
                v-model="item.ProfitPercentage"
                :label="$t.payrollDetails.profitPercent"
                disabled
              />

              <div class="payrollDetails-radio">
                <div class="radio-label">
                  <div class="radio-require2">*</div>
                  {{ $t.payrollDetails.paymentCurrency }}
                </div>
                <van-radio-group
                  v-model="item.SCId"
                  @change="calculatePayment(item)"
                  direction="horizontal"
                  :disabled="!isEdit ? true : false"
                >
                  <van-radio
                    v-for="(item, index) in form.PayrollRequestAmountList"
                    :name="item.SCId"
                    :key="index"
                    >{{ item.CurrencySn }}</van-radio
                  >
                </van-radio-group>
              </div>

              <van-field
                v-model="item.PaymentAmount"
                @blur="calculatePayment"
                :label="$t.payrollDetails.requestAmount"
                :placeholder="!isEdit ? '' : $t.meta.input"
                oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
                required
                :disabled="!isEdit ? true : false"
              />

              <van-field
                v-model="item.Remark"
                :label="$t.payrollDetails.remark"
                :placeholder="!isEdit ? '' : $t.meta.input"
                type="textarea"
                rows="3"
                :disabled="!isEdit ? true : false"
              />
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>

      <div
        class="title"
        v-if="form.ApprovalProcessList && form.ApprovalProcessList.length > 0"
      >
        {{ $t.payrollDetails.title5 }}
      </div>
      <van-steps
        direction="vertical"
        active-icon="wap-nav"
        active-color="#323233"
        :active="form.ApprovalProcessList.length"
        v-if="form.ApprovalProcessList && form.ApprovalProcessList.length > 0"
      >
        <van-step v-for="(process, index) in form.ApprovalProcessList" :key="index">
          <div style="margin-bottom: 5px">
            {{ $t.payrollDetails.position }} : {{ process.Position }}
          </div>
          <div style="margin-bottom: 5px">
            {{ $t.payrollDetails.username }} : {{ process.UserName }}
          </div>
          <div>
            {{ $t.payrollDetails.approvalState }} :
            <span v-if="process.ApprovalState == 0">{{ $t.payrollDetails.aState1 }}</span>
            <span v-if="process.ApprovalState == 1">{{ $t.payrollDetails.aState2 }}</span>
            <span v-if="process.ApprovalState == 2">{{ $t.payrollDetails.aState3 }}</span>
            <span v-if="process.ApprovalState == 3">{{ $t.payrollDetails.aState4 }}</span>
          </div>
        </van-step>
      </van-steps>

      <div
        class="title"
        v-if="form.ActualApprovalProcessList && form.ActualApprovalProcessList.length > 0"
      >
        {{ $t.payrollDetails.approvalResult }}
      </div>
      <van-steps
        direction="vertical"
        active-icon="wap-nav"
        active-color="#323233"
        :active="form.ActualApprovalProcessList.length"
        v-if="form.ActualApprovalProcessList && form.ActualApprovalProcessList.length > 0"
      >
        <van-step v-for="(result, index) in form.ActualApprovalProcessList" :key="index">
          <div style="margin-bottom: 5px">
            {{ $t.payrollDetails.position }} : {{ result.Position }}
          </div>
          <div style="margin-bottom: 5px">
            {{ $t.payrollDetails.approvalUser }} : {{ result.UserName }}
          </div>
          <div style="margin-bottom: 5px">
            {{ $t.payrollDetails.opinions }} : {{ result.ApprovalOpinions }}
          </div>
          <div>{{ $t.payrollDetails.auditTime }} : {{ result.AuditTime }}</div>
        </van-step>
      </van-steps>

      <div v-if="form.IsPageShowAuditFunction">
        <div class="title">{{ $t.payrollDetails.approvalOperate }}</div>

        <van-field
          v-model="form.ApprovalOpinions"
          :label="$t.payrollDetails.opinions"
          :placeholder="!isEdit ? '' : $t.meta.input"
          type="textarea"
          rows="3"
          required
        />

        <div style="margin: 16px">
          <van-button
            round
            block
            type="primary"
            @click="onApproval(2)"
            style="margin-top: 10px"
            >{{ $t.payrollDetails.agree }}</van-button
          >
          <van-button
            round
            block
            type="danger"
            @click="onApproval(3)"
            style="margin-top: 10px"
            >{{ $t.payrollDetails.disagree }}</van-button
          >
        </div>
      </div>

      <div style="margin: 16px">
        <van-button round block type="info" @click="onSubmit(false)" v-if="isEdit">
          <span v-if="pageType == 'new'">{{ $t.meta.submit }}</span>
          <span v-else>
            <span v-if="form.ApprovalState == 2 || form.ApprovalState == 3">{{
              $t.payrollDetails.resubmit
            }}</span>
            <span v-else>{{ $t.payrollDetails.saveChange }}</span>
          </span></van-button
        >
        <van-button
          round
          block
          type="default"
          style="margin-top: 10px"
          v-if="pageType == 'new'"
          @click="onSubmit(true)"
          >{{ $t.payrollDetails.tSave }}</van-button
        >
        <van-button
          round
          block
          type="danger"
          style="margin-top: 10px"
          v-if="pageType == 'edit' && form.ApprovalState != 2"
          @click="onCancel"
          >{{ $t.payrollDetails.cancelApply }}</van-button
        >
      </div>
    </van-form>

    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.payrollDetails.lastDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event)"
        @cancel="showTimePicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showAccountPicker" round position="bottom">
      <van-picker
        :title="$t.payrollDetails.bankAccount"
        show-toolbar
        :columns="form.BankAccountList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="accountConfirm"
        @cancel="showAccountPicker = false"
      />
    </van-popup>

    <div class="tool-bar" v-if="pageType == 'detail' || pageType == 'edit'">
      <van-button type="info" block @click="gotoPrint">{{ $t.meta.print }}</van-button>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  DatetimePicker,
  Switch,
  Uploader,
  Stepper,
  Picker,
  Collapse,
  CollapseItem,
  Step,
  Steps,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Switch)
  .use(Uploader)
  .use(Stepper)
  .use(Picker)
  .use(Collapse)
  .use(CollapseItem)
  .use(Step)
  .use(Steps);

export default {
  name: "payrollDetails",
  components: {},
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      pageType: "new",
      isEdit: false,
      FinancialAccountNoList: [],
      PRAId: "",
      activeBankAccount: [],
      activeWorkOrder: [1],
      form: {
        PaymentRecordNumber: "",
        SupplierVoucherNumber: "",
        CreateTime: "",
        LatestPaymentDate: "",
        Remark: "",
        UserId: "",
        ApprovalState: "",
        CompanyName: "",
        CompanyLogoPic: "",
        CustomerId: "",
        CustomerNumber: "",
        CustomerName: "",
        PayrollRequestAmountList: [],
        BankAccountList: [],
        PaymentWorkOrderList: [],
        ApprovalProcessList: [],
        ActualApprovalProcessList: [],
        CollectionAccountList: [],
        IsPageShowAuditFunction: 0,
        ApprovalOpinions: "",
      },
      //日期
      selectDate: new Date(),
      currentDate: "",
      showTimePicker: false,
      //picker
      showAccountPicker: false,
      itemIndex: 0,
    };
  },
  created() {
    const { Type, FinancialAccountNoList, PRAId } = this.$route.query;
    this.pageType = Type;
    if (this.pageType == "new") {
      this.FinancialAccountNoList = FinancialAccountNoList;
      this.isEdit = true;
      this.loadInfo("new");
    }
    if (this.pageType == "detail") {
      this.PRAId = PRAId;
      this.isEdit = false;
      this.getInfo("detail");
    }
    if (this.pageType == "edit") {
      this.PRAId = PRAId;
      this.isEdit = true;
      this.getInfo("edit");
    }
  },
  methods: {
    accountConfirm(e) {
      if (!e) {
        return;
      }
      this.form.CollectionAccountList[this.itemIndex].BankId = e.value;
      this.form.CollectionAccountList[this.itemIndex].AccountName = e.text;
      this.form.CollectionAccountList[this.itemIndex].BankName = e.BankName;
      this.form.CollectionAccountList[this.itemIndex].AccountNo = e.AccountNo;
      this.form.CollectionAccountList[this.itemIndex].BankRegion = e.BankRegion;
      this.form.CollectionAccountList[this.itemIndex].SwiftCodeBankNo = e.SwiftCodeBankNo;
      this.form.CollectionAccountList[this.itemIndex].BankAddress = e.BankAddress;
      this.form.CollectionAccountList[this.itemIndex].CompanyAddressEn =
        e.CompanyAddressEn;
      this.form.CollectionAccountList[this.itemIndex].EnterpriseId = e.EnterpriseId;
      this.form.CollectionAccountList[this.itemIndex].Currency = e.Currency;
      this.showAccountPicker = false;
    },
    pickerShow(index, pickerName) {
      if (!this.isEdit) {
        return;
      }
      this[pickerName] = true;
      this.itemIndex = index;
    },
    handleAdd() {
      this.form.CollectionAccountList.push({
        SCId: this.form.Currency.SCId,
        CurrencySn: this.form.Currency.CurrencySn, //币别
        Currency: "", //银行帐号币别
        BankId: "", //银行账户Id
        BankName: "", //开户行
        AccountName: "", //收款账户
        AccountNo: "", //银行账号
        BankRegion: "", //银行地区
        SwiftCodeBankNo: "", //银行代码
        BankAddress: "", //银行地址
        CompanyAddressEn: "", //企业英文地址
        EnterpriseId: "", //企业税号
      });
      this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
        titleMsg: this.$t.payrollDetails.addSuccess,
        type: "success",
      });
    },
    handleDelByIndex(index) {
      this.form.CollectionAccountList.splice(index, 1);
    },
    showTimeDate() {
      if (!this.isEdit) {
        return;
      }
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showTimePicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date) {
      var formatDate = (val) => {
        var value = new Date(val);
        var time = value.toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      this.form.LatestPaymentDate = formatDate(date);
      this.showTimePicker = false;
    },
    getInfo(type) {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = { PRAId: this.PRAId };
        this.$api.financialManagement
          .getBusinessPaymentRequestDetail(param)
          .then((res) => {
            this.applyData(res.data, type);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    loadInfo(type) {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = { FinancialAccountNoList: this.FinancialAccountNoList };
        this.$api.financialManagement
          .loadPayrollRequestApplicationInfo(param)
          .then((res) => {
            this.applyData(res.data, type);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    applyData(data, type) {
      this.form.CreateTime = data.CreateTime;
      this.form.CompanyName = data.CompanyName;
      this.form.CompanyLogoPic = data.CompanyLogoPic;
      this.form.CustomerId = data.CustomerId;
      this.form.CustomerNumber = data.CustomerNumber;
      this.form.CustomerName = data.CustomerName;
      this.form.PayrollRequestAmountList = data.PayrollRequestAmountList; //	付款金额列表

      this.form.PaymentWorkOrderList = data.PaymentWorkOrderList; //付款工作单列表
      if (this.form.PaymentWorkOrderList.length > 0) {
        for (var item of this.form.PaymentWorkOrderList) {
          this.getDic(item);
        }
      }

      this.calculatePayment();

      var bankAccountList = []; //	供应商银行账户列表
      data.BankAccountList.forEach((item) => {
        let data = {
          value: item.BankId,
          text: item.AccountName,
          BankName: item.BankName,
          AccountNo: item.AccountNo,
          BankRegion: item.BankRegion,
          SwiftCodeBankNo: item.SwiftCodeBankNo,
          BankAddress: item.BankAddress,
          CompanyAddressEn: item.CompanyAddressEn,
          EnterpriseId: item.EnterpriseId,
          Currency: item.Currency,
        };
        bankAccountList.push(data);
      });
      this.form.BankAccountList = bankAccountList;

      this.form.IsPageShowAuditFunction = data.IsPageShowAuditFunction; //页面是否显示审核功能
      this.form.ApprovalProcessList = data.ApprovalProcessList; //	审批流程列表
      this.form.ActualApprovalProcessList = data.ActualApprovalProcessList; //	审批结果列表

      if (type == "detail" || type == "edit") {
        this.PRAId = data.PRAId;
        this.form.PaymentRecordNumber = data.PaymentRecordNumber;
        this.form.SupplierVoucherNumber = data.SupplierVoucherNumber;
        this.form.LatestPaymentDate = data.LatestPaymentDate;
        this.form.Remark = data.Remark;
        this.form.UserId = data.UserId;
        this.form.ApprovalState = data.ApprovalState;
        this.form.CollectionAccountList = data.CollectionAccountList; //请款单收款账户列表
        for (var index in this.form.CollectionAccountList) {
          this.handleChange(index);
        }
      }
    },
    getDic(data) {
      if (data.TotalAmountReceivableDic) {
        var test1 = Object.entries(data.TotalAmountReceivableDic);
        var array1 = test1.map(([key, value]) => ({
          key,
          value,
        }));
        data.TotalAmountReceivable = array1;
      }

      if (data.TotalAmountPaymentDic) {
        var test2 = Object.entries(data.TotalAmountPaymentDic);
        var array2 = test2.map(([key, value]) => ({
          key,
          value,
        }));
        data.TotalAmountPayment = array2;
      }

      if (data.TotalProfitAmountDic) {
        var test3 = Object.entries(data.TotalProfitAmountDic);
        var array3 = test3.map(([key, value]) => ({
          key,
          value,
        }));
        data.TotalProfitAmount = array3;
      }

      if (data.TotalCreditAmountPaymentDic) {
        var test4 = Object.entries(data.TotalCreditAmountPaymentDic);
        var array4 = test4.map(([key, value]) => ({
          key,
          value,
        }));
        data.TotalCreditAmountPayment = array4;
      }
    },
    calculatePayment(row) {
      if (row) {
        if (row.PaymentAmount > row.CostAmount) {
          row.PaymentAmount = null;
          return;
        }
      }
      const allCurrency = this.form.PaymentWorkOrderList.filter((item) => {
        return item.PaymentAmount && item.PaymentAmount > 0;
      });
      //console.log(allCurrency, "allCurrency");

      for (var index in this.form.PayrollRequestAmountList) {
        this.form.PayrollRequestAmountList[index].PaymentAmount = 0;
        if (index == 0) {
          var currency1 = allCurrency.filter(
            (p) => p.SCId == this.form.PayrollRequestAmountList[0].SCId
          );
          //console.log(currency1);
          this.form.PayrollRequestAmountList[0].PaymentAmount = currency1.reduce(
            function (total, current) {
              return total + Number(current.PaymentAmount);
            },
            0
          );
        }
        if (index == 1) {
          var currency2 = allCurrency.filter(
            (p) => p.SCId == this.form.PayrollRequestAmountList[1].SCId
          );
          //console.log(currency2);
          this.form.PayrollRequestAmountList[1].PaymentAmount = currency2.reduce(
            function (total, current) {
              return total + Number(current.PaymentAmount);
            },
            0
          );
        }
        if (index == 2) {
          var currency3 = allCurrency.filter(
            (p) => p.SCId == this.form.PayrollRequestAmountList[2].SCId
          );
          //console.log(currency2);
          this.form.PayrollRequestAmountList[2].PaymentAmount = currency3.reduce(
            function (total, current) {
              return total + Number(current.PaymentAmount);
            },
            0
          );
        }
      }
    },
    handleChange(index) {
      var item = this.form.BankAccountList.find(
        (p) => p.value == this.form.CollectionAccountList[index].BankId
      );
      if (item) {
        this.form.CollectionAccountList[index].BankId = item.value;
        this.form.CollectionAccountList[index].AccountName = item.text;
        this.form.CollectionAccountList[index].BankName = item.BankName;
        this.form.CollectionAccountList[index].AccountNo = item.AccountNo;
        this.form.CollectionAccountList[index].BankRegion = item.BankRegion;
        this.form.CollectionAccountList[index].SwiftCodeBankNo = item.SwiftCodeBankNo;
        this.form.CollectionAccountList[index].BankAddress = item.BankAddress;
        this.form.CollectionAccountList[index].CompanyAddressEn = item.CompanyAddressEn;
        this.form.CollectionAccountList[index].EnterpriseId = item.EnterpriseId;
        this.form.CollectionAccountList[index].Currency = item.Currency;
      }
    },
    onSubmit(isTemSave) {
      var CostList = [];
      for (const cost of this.form.PaymentWorkOrderList) {
        if (this.pageType == "edit") {
          CostList.push({
            PRCId: cost.PRCId,
            Remark: cost.Remark,
            SCId: cost.SCId,
            PaymentAmount: parseFloat(cost.PaymentAmount),
          });
        } else {
          CostList.push({
            CostId: cost.CostId,
            Remark: cost.Remark,
            SCId: cost.SCId,
            PaymentAmount: parseFloat(cost.PaymentAmount),
          });
        }
      }
      this.$commonMethod.showLoading();
      var param = {
        SupplierVoucherNumber: this.form.SupplierVoucherNumber,
        LatestPaymentDate: this.form.LatestPaymentDate,
        Remark: this.form.Remark,
        PayrollRequestAmountList: this.form.PayrollRequestAmountList,
        CollectionAccountList: this.form.CollectionAccountList,
        CostList: CostList,
      };
      var request = null;
      if (this.pageType == "edit") {
        param.PRAId = this.PRAId;
        request = this.$api.financialManagement.editPayrollRequestApplication(param);
      } else {
        if (isTemSave) {
          param.ApprovalState = 2;
        } else {
          param.ApprovalState = null;
        }
        param.CustomerId = this.form.CustomerId;
        request = this.$api.financialManagement.addPayrollRequestApplication(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onCancel() {
      this.$commonMethod.showLoading();
      var param = {
        PRAId: this.PRAId,
      };
      this.$api.financialManagement
        .cancelPayrollRequestApplication(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onApproval(state) {
      this.$commonMethod.showLoading();
      var param = {
        PRAId: this.PRAId,
        ApprovalState: state,
        ApprovalOpinions: this.form.ApprovalOpinions,
      };
      this.$api.financialManagement
        .addPayrollRequestApprovalProcess(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    gotoPrint() {
      var param = {
        PRAId: this.PRAId,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createBusinessPaymentRequestDetailFile",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.payrollDetails {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .van-steps {
    background: transparent;
  }
  .collapse-title {
    color: #646566;
  }
  ::v-deep .van-step__line {
    display: none !important;
  }
  ::v-deep .van-collapse-item__content {
    padding: 0px 15px 15px 15px;
    background: transparent;
    border-top: 1px solid #ebedf0;
  }
  ::v-deep .van-collapse::after {
    border: none !important;
  }
  ::v-deep .van-collapse-item__title--expanded::after {
    display: none !important;
  }
  ::v-deep .van-radio__icon--disabled.van-radio__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-radio__label--disabled.van-radio__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }
  ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked {
    i {
      color: #1890ff;
      font-weight: bold;
    }
  }
  ::v-deep .van-checkbox__label--disabled.van-checkbox__label {
    color: #323233 !important;
    -webkit-text-fill-color: #323233 !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #999 !important;
      -webkit-text-fill-color: #999 !important;
    }
  }
  .payrollDetails-radio {
    padding: 10px 16px;
    border-bottom: 1px solid #ebedf0;
    .radio-require1 {
      color: red;
      position: absolute;
      left: 8px;
    }
    .radio-require2 {
      color: red;
      position: absolute;
      left: 24px;
    }
    .radio-label {
      color: #646566;
      margin-bottom: 10px;
      font-size: 14px;
    }
    .van-radio-group {
      ::v-deep .van-radio__label {
        font-size: 14px;
        color: #646566;
      }
    }
    .radio-button {
      font-size: 14px;
      text-align: right;
    }
  }
  .custom-date {
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .date-btn1 {
      width: 120px;
      display: inline-block;
      margin-right: 12px;
      font-size: 14px;
      color: #646566;
      .date-require {
        color: red;
        position: absolute;
        left: 8px;
      }
    }
    .date-btn2 {
      width: 50%;
      display: inline-block;
      font-size: 14px;
      .value {
        color: #323233;
      }
      .placeholder {
        color: #c3c3c3;
      }
    }
  }
  .custom-date-disabled {
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .date-btn1 {
      width: 120px;
      display: inline-block;
      margin-right: 12px;
      font-size: 14px;
      color: #999;
      .date-require {
        color: red;
        position: absolute;
        left: 8px;
      }
    }
    .date-btn2 {
      width: 50%;
      display: inline-block;
      font-size: 14px;
      .value {
        color: #999;
      }
    }
  }
  .subTotal {
    padding: 10px 16px;
    border-bottom: 1px solid #ebedf0;
    .subTotal-label {
      color: #999;
      margin-bottom: 10px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      .item1 {
        padding: 10px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 10px;
        background: #e8f4ff;
      }
    }
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      background: #1e90ff;
      .multi-table-title {
        font-size: 14px;
        color: #fff;
        width: 70%;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        font-weight: bold;
        color: #fff;
        width: 30%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
